module.exports = __webpack_public_path__ + "static/media/PersonalUse_Clipper_Script_fat.83f9a27a.ttf";